import "./SuccessMessage.css";
function SuccessMessage({ message }) {
  return <div className="success-message">{message}</div>;
}

export default SuccessMessage;
